/**
 * Administrar
 *
 * @author edmsamuel
 */
import React from 'react'
import Sidebar from './Sidebar'
import { FLAG_LOCAL_STORAGE_TOKEN } from '../Flags'
import { Redirect } from 'react-router'
import { connect } from 'react-redux'
import { buildPath } from '../Routes'
import ChatwootWidget from './chatwoot'

/**
 * Container
 *
 */
function Container(props) {
  const isLogged = (
    props.cuenta
    && props.cuenta.iId
    && props.cuenta.iActivo === true
  )

  if (localStorage.getItem(FLAG_LOCAL_STORAGE_TOKEN) == null) {
    return (<Redirect to={buildPath('/auth')} />)
  }

  const { styles } = props
  return (
    <div style={styles.root}>
      <div style={styles.header}>
        <Sidebar
          leftExtras={props.headerLeftExtras}
          rightExtras={props.headerRightExtras}
        />
      </div>

      <div style={styles.content}>
        {/* main content */}
        {isLogged ?
          props.children :

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
            <h2>Cargando...</h2>
            <h3>Un momento por favor</h3>
          </div>
        }
      </div>

      <ChatwootWidget
        account={isLogged ? props.cuenta : undefined}
      />
    </div>
  )
}

const buildStyles = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
  },

  header: {
    width: 65,
    borderRightWidth: 1,
    borderRightColor: theme.colors.border,
    borderRightStyle: 'solid',
    display: 'flex',
  },

  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
})

const connectedContainer = connect(
  state => ({
    theme: state.theme.values,
    styles: buildStyles(state.theme.values),
    cuenta: state.cuenta,
  })
)(Container)

export default connectedContainer
